/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Batch_Processing_JobInputs */

const en_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processing ${i?.name}…`)
};

const fr_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traitement en cours ${i?.name}…`)
};

const de_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verarbeitung von ${i?.name}…`)
};

const it_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elaborazione ${i?.name}…`)
};

const ru_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обработка ${i?.name}…`)
};

const es_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Procesando ${i?.name}…`)
};

const zh_cn2_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在处理 ${i?.name}…`)
};

const ja_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を処理中…`)
};

const hi_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} की प्रक्रिया जारी है…`)
};

const pt_pt2_batch_processing_job = /** @type {(inputs: Batch_Processing_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processando ${i?.name}…`)
};

/**
* | output |
* | --- |
* | "Processing {name}…" |
*
* @param {Batch_Processing_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_processing_job = /** @type {((inputs: Batch_Processing_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Processing_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_processing_job(inputs)
	if (locale === "de") return de_batch_processing_job(inputs)
	if (locale === "it") return it_batch_processing_job(inputs)
	if (locale === "ru") return ru_batch_processing_job(inputs)
	if (locale === "es") return es_batch_processing_job(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_processing_job(inputs)
	if (locale === "ja") return ja_batch_processing_job(inputs)
	if (locale === "hi") return hi_batch_processing_job(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_processing_job(inputs)
	return en_batch_processing_job(inputs)
});